import Icon from '../../../components/AppIcon';
import { AutomationStat } from '../types';

const StatsSection = () => {
  const stats: AutomationStat[] = [
    {
      id: "1",
      value: "Many",
      label: "Active Workflows Run Monthly",
      icon: "Activity" // Changed to emphasize activity/scale
    },
    {
      id: "2",
      value: "Many",
      label: "Hours Reclaimed for Clients",
      icon: "Clock"
    },
    {
      id: "3",
      value: "Significant",
      label: "Client Costs Saved",
      icon: "DollarSign" // Money talks - this is a powerful metric
    },
    {
      id: "4",
      value: "24/7",
      label: "System Uptime & Support",
      icon: "ShieldCheck"
    }
  ];

  return (
    <section className="relative -mt-8 z-20 px-4 sm:px-6 lg:px-8">
      {/* Floating container style for modern look */}
      <div className="max-w-7xl mx-auto bg-primary text-primary-foreground rounded-2xl shadow-xl overflow-hidden">
        
        {/* Subtle background pattern */}
        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:16px_16px]"></div>
        
        <div className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-primary-foreground/20">
          {stats.map((stat) => (
            <div key={stat.id} className="p-8 flex flex-col items-center text-center group hover:bg-white/5 transition-colors duration-300">
              <div className="mb-4 p-3 bg-white/10 rounded-full group-hover:scale-110 transition-transform duration-300">
                <Icon name={stat.icon} size={24} className="text-white" />
              </div>
              <div className="text-3xl lg:text-4xl font-bold tracking-tight mb-1">
                {stat.value}
              </div>
              <div className="text-sm font-medium opacity-90 uppercase tracking-wide">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;